import clsx from 'clsx';
import { UndecidedIcon } from 'components/Icons/UndecidedIcon';
import { Text } from 'components/UI/Typography/Text';

import styles from './UndecidedStatus.module.scss';

interface IUndecidedStatusProps {
  className?: string;
  hideText?: boolean;
}
export const UndecidedStatus = ({
  className,
  hideText,
}: IUndecidedStatusProps) => {
  return (
    <div className={styles.undecidedContainer}>
      <div className={styles.undecidedItem}>
        <UndecidedIcon className={clsx(styles.undecidedIcon, className)} />
        {!hideText && (
          <Text className={styles.undecidedText} variant="subtitle1">
            Undecided
          </Text>
        )}
      </div>
    </div>
  );
};
